import { render, staticRenderFns } from "./discard-modal.vue?vue&type=template&id=c69beb92&scoped=true&"
import script from "./discard-modal.vue?vue&type=script&lang=ts&"
export * from "./discard-modal.vue?vue&type=script&lang=ts&"
import style0 from "./discard-modal.vue?vue&type=style&index=0&id=c69beb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69beb92",
  null
  
)

export default component.exports